export default "__VITE_ASSET__BnXA4F53__"